import { useCallback, useEffect, useState } from "react";
import { debounce } from "../utils/helper";
import { toaster } from "../utils/toast";
import useAxios from "./useAxios";

const useListPage = ({ fetchUrl, responseKey, onSuccess }) => {
    const [searchText, setSearchText] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [limit, setLimit] = useState(10);
    const { getData, isLoading } = useAxios();
    const [list, setList] = useState([]);
    const [totalCount, setTotalCount] = useState(0);
    const [totalPages, setTotalPages] = useState(0);
    const [selectedItem, setSelectedItem] = useState(null);
    const [isShowModal, setIsShowModal] = useState(false);
    const [isFormSubmitting, setIsFormSubmitting] = useState(false);

    const fetchData = useCallback(async () => {
        const url = `${fetchUrl}?pageNumber=${currentPage}&limit=${limit}&searchText=${searchText}`;
        const { success, data, message } = await getData(url);
        if (success) {
            setList(data[responseKey]);
            setTotalPages(data.totalPages);
            setTotalCount(data.totalCount);
            if (onSuccess) onSuccess(data);
        } else {
            toaster({ message, success });
        }
    }, [currentPage, searchText, limit, getData, fetchUrl, responseKey, onSuccess]);

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    useEffect(() => {
        setCurrentPage(1);
    }, [searchText, limit]);

    const handleSearchChange = debounce((e) => setSearchText(e.target.value), 500);

    const handleEdit = (item) => {
        setIsShowModal(true);
        setSelectedItem(item);
    };

    const resetValue = () => {
        setIsFormSubmitting(false);
        setIsShowModal(false);
        setSelectedItem(null);
    };

    const closeModal = () => {
        setSelectedItem(null);
        setIsShowModal(false);
    };

    return {
        list,
        totalCount,
        totalPages,
        currentPage,
        setCurrentPage,
        limit,
        setLimit,
        searchText,
        handleSearchChange,
        selectedItem,
        setSelectedItem,
        isShowModal,
        setIsShowModal,
        isFormSubmitting,
        setIsFormSubmitting,
        isLoading,
        handleEdit,
        closeModal,
        resetValue,
        refetch: fetchData,
    };
};

export default useListPage;
